import { rubIcon } from "../../../../shared/assets/svg/rubIcon";
import { Stack } from "../../../../shared/ui/Stack/Stack";
import { Text } from "../../../../shared/ui/Text/Text";
import { FixedProstheticsPriceData, ImplantProstheticsPriceData, RemovableProstheticsPriceData,  } from "../lib/data";
import styles from './ProstheticsPrice.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 


const ProstheticsPrice = () => {

    useGSAP(() => {
        gsap.to(".prostheticsPrice", { "--opacity": 1, 
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1,
                                    scrollTrigger: {
                                        trigger: ".prostheticsPrice"
        }});
    }, [])

    return (  
        <div className={styles.container}>
            <Stack     
                    justifyContent = 'justifyCenter'                    
            >
                <Text type="h2" size='l' className={`prostheticsPrice ${styles.title}`}>
                    СТОИМОСТЬ УСЛУГ
                </Text>    
            </Stack>

                <Text  size='m' className={styles.titlePrice}>
                            Несъемное протезирование
                </Text> 
                {FixedProstheticsPriceData.map(element => 
                    <div
                        className={styles.priceContent}
                        key={element.id}
                    >
                        <Text  size='m' className={styles.text}>
                            {element.service}
                        </Text>  
                        <Text  size='m' className={styles.price}>
                            {element.price} {rubIcon()}
                        </Text>    
                    </div>
            )}
                <Text  size='m' className={styles.titlePrice}>
                            Cъемное протезирование
                </Text> 
                {RemovableProstheticsPriceData.map(element => 
                    <div
                        className={styles.priceContent}
                        key={element.id}
                    >
                        <Text  size='m' className={styles.text}>
                            {element.service}
                        </Text>  
                        <Text  size='m' className={styles.price}>
                            {element.price} {rubIcon()}
                        </Text>    
                    </div>
            )}
                <Text  size='m' className={styles.titlePrice}>
                            Протезирование на имплантатах
                </Text> 
                {ImplantProstheticsPriceData.map(element => 
                    <div
                        className={styles.priceContent}
                        key={element.id}
                    >
                    
                        <Text  size='m' className={styles.text}>
                            {element.service}
                        </Text>  
                        <Text  size='m' className={styles.price}>
                            {element.price} {rubIcon()}
                        </Text>    
                    </div>
            )}
        </div>
    );
}
export default ProstheticsPrice;